import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { Binary } from '@angular/compiler';

@Injectable()
export class JwtService {

  getToken(): String {
    return window.sessionStorage['jwtToken'];
  }

  saveToken(token: String) {
    window.sessionStorage['jwtToken'] = token;
  }

  destroyToken() {
    window.sessionStorage.removeItem('jwtToken');
    window.sessionStorage.removeItem('selectedApp');
    window.sessionStorage.removeItem('localeId');
  }

  getApp(): SelectedAppResult {
    var selectedApp = window.sessionStorage['selectedApp'];
    if (selectedApp) {
      return JSON.parse(selectedApp);
    }
    return { "Id": 0, "Name": "" };
  }

  saveApp(appObject: String) {
    window.sessionStorage['selectedApp'] = appObject;
  }

  getDecodeToken(): TokenTesult {
    var token = this.getToken();
    var decodedToken = {};
    if (typeof token !== 'undefined') {
      return jwtDecode(token);
    }

    return {
      "FirstName": "",
      "Id": 0,
      "LastName": "",
      "Title": "",
      "UserName": "",
      "FirstTimePassword": false,
      "HasDataProtectionAgreement": false,
      "Role": 0
    };
  }
}

interface SelectedAppResult {
  Id: Number;
  Name: String;
}

interface TokenTesult {
  FirstName: String;
  Id: Number;
  LastName: String;
  Title: String;
  UserName: String,
  FirstTimePassword: Boolean,
  HasDataProtectionAgreement: Boolean,
  Role: Number
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/authentication/guards/jwt.service.ts